import React from "react";

import DashboardActiveTelemetryKpi from "./DashboardActiveTelemetryKpi";
import DashboardInactiveTelemetryKpi from "./DashboardInactiveTelemetryKpi";
import DashboardFieldAlertsKpi from "./DashboardFieldAlertsKpi";
import DashboardTrailPeopleKpi from "./DashboardTrailPeopleKpi";

import { withTranslation } from "react-i18next";

function KpisGadgets(props) {
  let contentGadgets = [];

  function KPIInactiveTelemetry() {
    contentGadgets.push(
      <DashboardInactiveTelemetryKpi
        key="inactive-telemetry"
        farm_id={props.farm_id}
      />
    );
  }
  function KPIFieldAlerts() {
    contentGadgets.push(
      <DashboardFieldAlertsKpi
        key="field-alerts"
        prefs={props.fieldAlertPrefs}
        onChangePrefs={props.onChangeFieldAlertPrefs}
      />
    );
  }
  function KPITrailPeople() {
    contentGadgets.push(
      <DashboardTrailPeopleKpi
        key="trail-people"
        farmId={props.farm_id}
        operators={props.operators}
        equipment={props.equipment}
        visibleIds={props.visibleTrailOperatorIds}
        visibleMachineIdents={props.visibleTrailMachineIdents}
        roster={props.trailRoster}
        operatorTraceColors={props.operatorTraceColors}
        selected={props.mapTrailMode === "people"}
        noticeOpen={props.trailNoticeOpen}
        onSelect={props.onSelectPeopleTrails}
        onCloseNotice={props.onCloseTrailNotice}
        onApplyPeriod={props.onApplyPeopleTrailPeriod}
        onChange={props.onChangeVisibleTrailOperators}
        onChangeMachines={props.onChangeVisibleTrailMachines}
        onChangeRoster={props.onChangeTrailRoster}
        tracePeriodStart={props.tracePeriodStart}
        tracePeriodEnd={props.tracePeriodEnd}
        trailDayKeys={props.trailDayKeys}
        onToggleDay={props.onToggleTrailDay}
        onToggleHour={props.onToggleTrailHour}
        landplotPickMode={props.landplotPickMode}
        onToggleLandplotPickMode={props.onToggleLandplotPickMode}
      />
    );
  }

  function KPIActiveTelemetry() {
    contentGadgets.push(
      <DashboardActiveTelemetryKpi
        key="active-telemetry"
        farm_id={props.farm_id}
        operatorTraceColors={props.operatorTraceColors}
        onOperatorTraceColorChange={props.onOperatorTraceColorChange}
        selected={props.mapTrailMode === "active"}
        activeHours={props.activeTraceHours}
        onSelect={props.onSelectActiveTrails}
        onHours={props.onActiveTraceHours}
        onSessions={props.onActiveTelemetrySessions}
      />
    );
  }

  function renderGadgets() {
    KPIActiveTelemetry();
    KPIInactiveTelemetry();
    KPIFieldAlerts();
    KPITrailPeople();

    return contentGadgets;
  }

  return <div>{renderGadgets()}</div>;
}

export default withTranslation()(KpisGadgets);
